function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcHidden = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.199,
    height: 23.176,
    viewBox: "0 0 27.199 23.176",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4040"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4038"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4576",
    d: "M26.2 7.144a23.892 23.892 0 0 0-3.744-3.558 19.639 19.639 0 0 0-4.082-2.453A12.766 12.766 0 0 0 13.278 0a12.766 12.766 0 0 0-5.1 1.134A19.639 19.639 0 0 0 4.1 3.586 23.9 23.9 0 0 0 .354 7.144L0 7.584l.354.44A23.9 23.9 0 0 0 4.1 11.581a19.634 19.634 0 0 0 4.08 2.453 12.764 12.764 0 0 0 5.1 1.134 12.764 12.764 0 0 0 5.1-1.134 19.634 19.634 0 0 0 4.082-2.453A23.893 23.893 0 0 0 26.2 8.024l.354-.44zm-4.625 3.345c-1.952 1.495-4.976 3.276-8.3 3.276s-6.347-1.781-8.3-3.276a24 24 0 0 1-3.147-2.906A23.923 23.923 0 0 1 4.953 4.7c1.957-1.5 4.991-3.3 8.325-3.3s6.348 1.782 8.3 3.276a23.993 23.993 0 0 1 3.151 2.905 23.992 23.992 0 0 1-3.151 2.905",
    transform: "translate(.321 4.088)",
    style: {
      strokeWidth: ".5px",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4577",
    d: "M547.382 188.126a4.61 4.61 0 1 0 .361 1.789 4.582 4.582 0 0 0-.361-1.789m-4.235 4.983a3.194 3.194 0 1 1 3.193-3.194 3.2 3.2 0 0 1-3.193 3.194",
    transform: "translate(-529.547 -178.244)",
    style: {
      strokeWidth: ".5px",
      stroke: "#000"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcHidden);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-hidden.59dc8eb7678f8aae0c24609eac939c29.svg";